export const messages = {
  en: {
    remainingParkingSpace: {
      title: 'Remaining Parking Space',
      total: 'Total Parking Spaces',
      freeCount: 'Remaining Spaces',
      createTime: 'Collection Time',
      operation: 'Operation',
      refresh: 'Refresh',
      unit: 'units',
      fetchError: 'Failed to fetch parking space data'
    }
  },
  zh: {
    remainingParkingSpace: {
      title: '剩余车位',
      total: '总车位数',
      freeCount: '剩余车位数',
      createTime: '采集时间',
      operation: '操作',
      refresh: '刷新',
      unit: '位',
      fetchError: '获取车位数据失败'
    }
  }
}